/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { GetLoginOptionsOptions, GetLoginOptionsResponses } from '../models/GetLoginOptions'
import { client } from '#shared/api/client'

/**
 * @description Takes no body: the challenge is the same for everyone, and nothing about
 * the user is asked before the authenticator has spoken.
 * @summary The challenge any registered credential may answer.
 * {@link /api/webauthn/login-options}
 */
export function getLoginOptions<ThrowOnError extends boolean = true>(options: Options<GetLoginOptionsOptions, ThrowOnError> = {}): Promise<RequestResult<GetLoginOptionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/webauthn/login-options', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<GetLoginOptionsResponses, ThrowOnError>>
}
